import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-sort\">\n<path d=\"M129.4,35l32.3,30.1c2.8,2.6,7.1,2.4,9.7-0.3c2.6-2.8,2.4-7.1-0.3-9.7l-43.8-40.8c-4.4-4.1-11.5-1-11.5,5v161\n\tc0,3.8,3.1,6.8,6.8,6.8s6.8-3.1,6.8-6.8V35z M68.8,164.4l-32.3-30.1c-2.8-2.6-7.1-2.4-9.7,0.3c-2.6,2.8-2.4,7.1,0.3,9.7L71,185.2\n\tc4.4,4.1,11.5,1,11.5-5v-161c0-3.8-3.1-6.8-6.8-6.8s-6.8,3.1-6.8,6.8V164.4L68.8,164.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol